import { message, Input, Select, Alert } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  cuentaMask,
  InputItem,
  InputNumberItem,
  ButtonItem,
  SwitchItem,
  ErrorItem,
  TextAreaItem,
  TourItem,
} from "../../../../Components/Items";
import { PlusOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import AsistenteDepreciacionLISR from "../../../../Components/AsistenteDepreciacionLISR";

const { Option } = Select;

const CUENTAS = [
  { campo: "cuentaActivoId", flag: "generarCuentaHijaActivo", label: "Cuenta del Activo", tooltip: "Cuenta contable donde se registra el costo de adquisición. Se carga al alta de cada unidad y se cancela (abona) al venderla o darla de baja. NUNCA se toca en las corridas periódicas de depreciación." },
  { campo: "cuentaDepreciacionAcumuladaId", flag: "generarCuentaHijaDepreciacionAcumulada", label: "Cuenta de Depreciación Acumulada", tooltip: "Cuenta contable (contra-activo) que se abona en cada corrida periódica de depreciación, y se cancela (carga) al vender o dar de baja la unidad." },
  { campo: "cuentaCostoGastoActivoId", flag: "generarCuentaHijaCostoGastoActivo", label: "Cuenta de Costo o Gasto", tooltip: "Cuenta de resultados que se carga (gasto) en cada corrida periódica de depreciación. Solo se usa para la depreciación periódica, no en venta ni baja." },
  { campo: "cuentaUtilidadActivoId", flag: "generarCuentaHijaUtilidadActivo", label: "Cuenta de Utilidad de Activo", tooltip: "Se abona solo cuando se VENDE un activo por un precio mayor a su valor en libros (la diferencia es una utilidad)." },
  { campo: "cuentaPerdidaActivoId", flag: "generarCuentaHijaPerdidaActivo", label: "Cuenta de Pérdida de Activo", tooltip: "Se carga cuando se vende un activo por menos de su valor en libros, o cuando se da de baja (desecho/siniestro/donación) por el valor en libros restante." },
];

class EditarTipoDeActivo extends Component {
  formRef = React.createRef();
  refCuentas = React.createRef();
  refDepreciacion = React.createRef();
  state = {
    loading: false,
    openTour: false,
    openAsistenteDepreciacion: false,
    objetoCuentaContable: null,
    modalAgregarCuentaContable: false,
    utilizado: false,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  cerrarEditarTipoDeActivo(codigo) {
    this.props.cerrarEditarTipoDeActivo(codigo);
    this.formRef.current.resetFields();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentascontables/selectCuentasContables",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "activosFijos/datosTipoDeActivo",
        { empresaId: this.props.empresaId, familiaId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error, no se encontró información del Tipo de Activo");
        } else {
          if (res.data.utilizado) {
            message.info("No se puede modificar toda la información ya que este Tipo de Activo ya tiene Activos dados de alta");
          }
          this.formRef.current.setFieldsValue({ ...res.data });
          this.setState({ utilizado: res.data.utilizado });
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/editarTipoDeActivo",
        { empresaId: this.props.empresaId, familiaId: this.props.id, ...values },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha editado el Tipo de Activo");
          this.formRef.current.resetFields();
          this.cerrarEditarTipoDeActivo(res.data.codigo);
        } else {
          message.error(res.data.message || "Hubo un error y el Tipo de Activo no se editó");
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }
  renderCuenta({ campo, flag, label, tooltip }) {
    return (
      <React.Fragment key={campo}>
        <FormItem label={label} margin tooltip={{ title: tooltip }}>
          <Input.Group compact>
            <FormItem name={campo} required noStyle>
              <SelectItem placeholder={label} width="65%" disabled={this.state.utilizado}>
                {this.state.objetoCuentaContable}
              </SelectItem>
            </FormItem>
            <ButtonItem
              blanco
              disabled={this.state.utilizado}
              icon={<PlusOutlined />}
              style={{ width: "15%" }}
              onClick={this.abrirAgregarCuentaContable.bind(this)}
            />
            <FormItem name={flag} valuePropName="checked" noStyle>
              <SwitchItem
                disabled={this.state.utilizado}
                checkedChildren="Genera hija"
                unCheckedChildren="Compartida"
                style={{ width: "20%", marginLeft: 8 }}
              />
            </FormItem>
          </Input.Group>
        </FormItem>
      </React.Fragment>
    );
  }

  // Mercancias en transito: no es una de las 5 cuentas del activo (no clona
  // subcuenta hija) pero hace falta para comprar un activo fijo con el flujo
  // "capturo la factura ahora y recibo despues".
  //
  // A diferencia de las otras 5, esta SI se puede editar aunque el Tipo de
  // Activo ya este utilizado: no se copia a ningun Activo ni a ninguna unidad,
  // se lee en el momento de recibir, y lo normal es tener que agregarla despues
  // (cuando alguien intenta comprar por ese flujo y el sistema se lo pide).
  renderCuentaTransito() {
    return (
      <FormItem
        label="Cuenta de Mercancías en Tránsito"
        margin
        tooltip={{
          title:
            "Solo se usa al comprar: si capturas la factura sin recibir todavía, el valor del activo queda en esta cuenta y se abona al momento de recibirlo. Si siempre recibes junto con la factura o compras por Orden de Compra, puedes dejarla vacía.",
        }}
      >
        <Input.Group compact>
          <FormItem name="cuentaTransitoId" noStyle>
            <SelectItem placeholder="Cuenta de Mercancías en Tránsito" width="85%">
              {this.state.objetoCuentaContable}
            </SelectItem>
          </FormItem>
          <ButtonItem
            blanco
            icon={<PlusOutlined />}
            style={{ width: "15%" }}
            onClick={this.abrirAgregarCuentaContable.bind(this)}
          />
        </Input.Group>
      </FormItem>
    );
  }
  render() {
    const steps = [
      { title: "Editar Tipo de Activo", description: "Si este Tipo de Activo ya tiene Activos dados de alta, sus cuentas y reglas de depreciación quedan bloqueadas para no romper la contabilidad ya generada — solo nombre/descripción/folio siguen siendo editables.", target: null },
      { title: "Las 5 cuentas contables", description: "Cada cuenta tiene su propio switch de 'genera cuenta hija'. Si el Tipo de Activo ya está en uso, este switch queda bloqueado.", target: () => this.refCuentas.current },
      { title: "Depreciación", description: "Fórmula de línea recta: (Costo − Valor Residual) × Depreciación Anual %, por la frecuencia elegida.", target: () => this.refDepreciacion.current },
    ];
    return (
      <>
        <ModalItem
          title={
            <span>
              Editar Tipo de Activo{" "}
              <ButtonItem type="link" size="small" blanco onClick={() => this.setState({ openTour: true })}>¿Cómo funciona?</ButtonItem>
              <ButtonItem type="link" size="small" blanco disabled={this.state.utilizado} onClick={() => this.setState({ openAsistenteDepreciacion: true })}>Asistente de Depreciación (Ley ISR)</ButtonItem>
            </span>
          }
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarEditarTipoDeActivo.bind(this)}
          paddingTop
          width={700}
        >
          <Form
            ref={this.formRef}
            name="editarTipoDeActivo"
            layout
            bottom={
              <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Editar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <FormItem name="nombre" label="Nombre" required max={100} margin pattern tooltip={{ title: "Nombre de la categoría, ej. 'Equipo de Cómputo'." }}>
              <InputItem placeholder="Nombre" />
            </FormItem>
            <FormItem name="descripcion" label="Descripción" margin pattern tooltip={{ title: "Descripción libre de qué bienes agrupa esta categoría." }}>
              <TextAreaItem placeholder="Descripción" />
            </FormItem>

            <div ref={this.refCuentas}>
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 12 }}
                message="Qué hace “Genera hija”"
                description={
                  <span>
                    Con el switch en <strong>Genera hija</strong>, cada Activo de este tipo recibe su propia subcuenta, clonada de la cuenta de aquí abajo. Se crea <strong>una sola vez, al dar de alta el Activo</strong> — no por cada unidad física.
                    Con el switch en <strong>Compartida</strong>, todos los Activos de este tipo usan la misma cuenta.
                    Cada cuenta tiene su propio switch, y un Activo puede saltarse esta regla si al darlo de alta captura su propia cuenta.
                  </span>
                }
              />
              {CUENTAS.map((cuenta) => this.renderCuenta(cuenta))}
              {this.renderCuentaTransito()}
            </div>

            <div ref={this.refDepreciacion}>
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 12 }}
                message="Fórmula de depreciación (Línea Recta)"
                description={
                  <span>
                    <strong>Depreciación anual = (Costo de adquisición − Valor Residual) × Depreciación Anual %</strong>. La depreciación mensual es ese monto entre 12, y cada corrida deprecia los meses de la frecuencia elegida.
                  </span>
                }
              />
              <FormItem
                name="metodoDepreciacionDefault"
                label="Método de Depreciación"
                required
                margin
                tooltip={{ title: "Método por default para los Activos de este tipo. Por ahora solo está implementada Línea Recta." }}
              >
                <SelectItem placeholder="Método de Depreciación" disabled={this.state.utilizado}>
                  <Option value={1}>Línea recta</Option>
                </SelectItem>
              </FormItem>
              <FormItem
                name="frecuenciaDepreciacionDefault"
                label="Frecuencia de Depreciación"
                required
                margin
                tooltip={{ title: "Cada cuánto se corre la depreciación: Mensual, Bimestral, Trimestral, Semestral o Anual." }}
              >
                <SelectItem placeholder="Frecuencia de Depreciación" disabled={this.state.utilizado}>
                  <Option value={1}>Mensual</Option>
                  <Option value={2}>Bimestral</Option>
                  <Option value={3}>Trimestral</Option>
                  <Option value={4}>Semestral</Option>
                  <Option value={5}>Anual</Option>
                </SelectItem>
              </FormItem>
              <FormItem
                name="porcentajeDepreciacionAnualDefault"
                label="Depreciación Anual (%)"
                required
                margin
                tooltip={{ title: "Qué porcentaje del costo (menos el valor residual) se deprecia cada año, ej. 10% anual = 10 años de vida útil." }}
              >
                <InputNumberItem placeholder="Ej. 10" porcentaje min={0.01} max={100} disabled={this.state.utilizado} />
              </FormItem>
              <FormItem
                name="valorResidualDefaultPorcentaje"
                label="Valor Residual"
                margin
                tooltip={{ title: "% del costo que nunca se deprecia." }}
              >
                <InputNumberItem placeholder="Ej. 10" porcentaje min={0} max={100} disabled={this.state.utilizado} />
              </FormItem>
            </div>

            <FormItem name="prefijoSerieActivo" label="Prefijo de Serie" margin pattern tooltip={{ title: "Texto fijo antes del folio consecutivo de cada unidad, ej. 'MOB-'." }}>
              <InputItem placeholder="Ej. MOB-" />
            </FormItem>
            <FormItem name="longitudFolioActivo" label="Longitud de Folio" margin tooltip={{ title: "Dígitos del consecutivo, rellenado con ceros." }}>
              <InputNumberItem placeholder="Ej. 5" min={1} max={10} />
            </FormItem>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <TourItem open={this.state.openTour} onClose={() => this.setState({ openTour: false })} steps={steps} />
        <AsistenteDepreciacionLISR
          visible={this.state.openAsistenteDepreciacion}
          onClose={() => this.setState({ openAsistenteDepreciacion: false })}
          onAplicar={({ porcentaje, metodo }) =>
            this.formRef.current.setFieldsValue({
              porcentajeDepreciacionAnualDefault: porcentaje,
              metodoDepreciacionDefault: metodo,
            })
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarTipoDeActivo);
